import Alpine from 'alpinejs'
import AlpineI18n from 'alpinejs-i18n'

import { Spinner } from 'components'
import Store from 'stores/courier_signup'
import PhoneNumberForm from './_phone_number_form'
import VerificationCode from './_verification_code'

function StaticForms () {
  window.Alpine = Alpine
  Alpine.store('CourierSignup', Store)
  const store = Alpine.store('CourierSignup')

  const CourierSignup = () => ({
    init () {
      const screen = window.global.SCREEN
      if (screen) {
        store.setActiveStage(screen)
        Store.setActiveFormStep(0)
        store.phoneNumber = window.global.USER_PHONE
        store.recruiterInvited = window.global.RECRUITER_INVITED
      }
    },

    toggleLocales () {
      const locale = store.localeCode === 'ar' ? 'en' : 'ar'
      const direction = locale === 'ar' ? 'rtl' : 'ltr'
      const switchLocaleUrl = new URL(window.global.LOCALE_SWITCHER_URL, window.location.origin)
      switchLocaleUrl.searchParams.append('language', locale)

      fetch(switchLocaleUrl.href)
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            store.localeCode = locale
            window.AlpineI18n.locale = locale
            I18n.locale = locale
            document.querySelector('html').setAttribute('dir', direction)
            document.querySelector('html').setAttribute('lang', locale)
          }
        })
    },

    spinner: Spinner()
  })

  Alpine.data('CourierSignup', CourierSignup)
  Alpine.data('PhoneNumberForm', PhoneNumberForm)
  Alpine.data('VerificationCode', VerificationCode)

  Alpine.plugin(AlpineI18n)
  window.AlpineI18n.create(I18n.locale, I18n.translations)
  Alpine.start()
}

export default StaticForms
